import { useTranslation } from '@crehana/i18n';
import { nextSeoDefaultProps } from '@crehana/next';
import memoize from 'lodash/memoize';
import { NextSeo } from 'next-seo';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { useLocation } from 'react-router-dom';

import routes from './routes/config';
import type { UserDashboardLocaleKeys } from './types';

const getCurrentRoute = memoize((url?: string) => {
  if (url === '/') {
    return routes[0];
  }

  const rootPath =
    url
      ?.split('/')
      .filter(item => item.length)
      .filter(r => r !== 'panel')[0] || routes[0];

  return routes.find(r => r.path.replace(/\//g, '') === rootPath);
});

export const getPageTitleFromUrl = (url?: string): UserDashboardLocaleKeys => {
  const currentRoute = getCurrentRoute(url);

  const pageTitle = `UD_${
    currentRoute ? currentRoute.key : 'ENROLLMENTS'
  }_TITLE` as UserDashboardLocaleKeys;

  return pageTitle;
};

const SEO: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const pageTitle = t(getPageTitleFromUrl(location.pathname));

  return (
    <NextSeo {...nextSeoDefaultProps} title={pageTitle} noindex nofollow />
  );
};

export default SEO;
